import type { Figures, KpiKey } from '../../lib/kpi';
import { formatKpi, KPI_CATALOG } from './kpiCatalog';

type Props = {
  kpis: KpiKey[];
  totals: Figures;
  currency: string;
};

/** One card per granted KPI, summed over the chosen operators and days. */
export function KpiCards({ kpis, totals, currency }: Props) {
  return (
    <section aria-label="Key figures" className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {kpis.map((key) => (
        <div key={key} className="rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4">
          <div className="text-xs font-medium text-[var(--co-muted)]">{KPI_CATALOG[key].label}</div>
          <div className="mt-1 text-2xl font-semibold text-[var(--co-text)]">{formatKpi(key, totals, currency)}</div>
          <p className="mt-1 text-[11px] leading-tight text-[var(--co-muted)]">{KPI_CATALOG[key].hint}</p>
        </div>
      ))}
    </section>
  );
}
